// This composable is used to get fields with the category Afterward for all forms
import type { FieldValueResult } from '@/components/documents/Foxit/FormMapping/composables/FieldValueProvider'
import { useFormFillHelper } from '@/components/documents/Foxit/FormMapping/composables/FormFillHelper'
import type { MappedCartItem } from '@/components/documents/Foxit/FormMapping/composables/FormFillHelper'
import { PbProductType } from '@/enums/PbProductType'
import { PbSubcategory } from '@/enums/PbSubcategory'

export const useAfterwardFields = () => {
	const { findCartItems, getFieldPrice, getFieldDescription } =
		useFormFillHelper()

	const afterwardCateringDesc = (
		fieldName: string,
		passedItems?: MappedCartItem[]
	): FieldValueResult[] => {
		const items =
			passedItems ??
			findCartItems(PbProductType.Afterward, PbSubcategory.AfterwardCatering)

		return [
			{
				name: fieldName,
				value: getFieldDescription(items),
				format: false,
				section: 'cashAdvance',
			},
		]
	}

	const afterwardCateringPrice = (
		fieldName: string,
		passedItems?: MappedCartItem[]
	): FieldValueResult[] => {
		const items =
			passedItems ??
			findCartItems(PbProductType.Afterward, PbSubcategory.AfterwardCatering)

		return [
			{
				name: fieldName,
				value: getFieldPrice(items),
				format: true,
				section: 'cashAdvance',
				supplementalItems: items,
			},
		]
	}

	const afterwardCateringFields = (
		fieldNames: Record<string, string>
	): FieldValueResult[] => {
		const items = findCartItems(
			PbProductType.Afterward,
			PbSubcategory.AfterwardCatering
		)

		return [
			...afterwardCateringDesc(fieldNames.description, items),
			...afterwardCateringPrice(fieldNames.price, items),
		]
	}

	return {
		afterwardCateringDesc,
		afterwardCateringPrice,
		afterwardCateringFields,
	}
}
